import React, { Component, ReactNode } from 'react'
import PopupHeading from './PopupHeading'

interface PopupHeadingRowProps {
  heading: string
  doc?: string
  children: ReactNode
}

export default class PopupHeadingRow extends Component<PopupHeadingRowProps> {
  render () {
    return (
      <div className="flex flex-col lg:flex-row lg:justify-between items-start mb-5 gap-5">
        <PopupHeading text={this.props.heading} doc={this.props.doc} />
        <div className="flex gap-5">
          {this.props.children}
        </div>
      </div>
    )
  }
}
